import { render } from "./PriceInquiryDetail.vue?vue&type=template&id=5c1c727e&scoped=true&ts=true"
import script from "./PriceInquiryDetail.vue?vue&type=script&lang=ts"
export * from "./PriceInquiryDetail.vue?vue&type=script&lang=ts"

import "./PriceInquiryDetail.vue?vue&type=style&index=0&id=5c1c727e&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c1c727e"]])

export default __exports__